<template>
  <div class="login">
    <VkdHeader :barData="barData"></VkdHeader>
    <div class="mainBd pd25">
      <div class="title">用户名</div>
      <van-field autofocus autosize v-model="username" clearable placeholder="正式为邮箱前缀，其他为Staff账户名" error-message></van-field>
      <div class="title">密码</div>
      <van-cell-group class="eye-box" style="border: 5px;">
        <van-field
          autosize
          v-model="password"
          :type="pwdType"
          error-message
          placeholder="请输入密码"
          :right-icon="eyes_icon"
          @click-right-icon="eyeChange"
        ></van-field>
      </van-cell-group>
      <!--<div class="title">图形验证码</div>
       <van-cell-group class="picture-box">
        <van-field
          style="margin-right:30px;"
          autosize
          v-model="captchaCode"
          clearable
          error-message
          @focus="setFrequency"
          @blur="isFrequency=false"
          placeholder="请输入图形验证码"
        ></van-field>
        <div class="picture-code" @click="initPictureFn">
          <img :src="pictureSrc" alt />
        </div>
      </van-cell-group> -->
      <div
        class="fivefrequency"
        v-if="isFrequency"
        style="padding-top:15px;"
      >验证码连续5次输入错误，1小时内将禁止该账户再次登录</div>
      <div class="loginBtn">
        <van-button type="warning" size="large" :disabled="loginBtnStatus" @click="handleLogin">下一步</van-button>
      </div>
      <div class="forgetPassword" @click="handleForgetPassword">忘记密码?</div>
    </div>
    <Alert v-if="visible" :img='img' :imgs="imgs" :tops="tops" @loginfun='loginfun' @visiblefalse='visiblefalse' @imgfundata='imgfundata'></Alert>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { navigationTo, isVkhybrid } from "../lib/util.js";
import VkdHeader from "@/components/header.vue";
import HOSTS from "../config.js";
import axiosmy from "axios";
import "vant/lib/index.css";
import { Icon } from "vant";
import Alert from "./Alert"
const BSEURL = `${HOSTS.login}/sso/external`;

export default {
  name: "login",
  data() {
    return {
      barData: {
        title: "欢迎使用VIPKID业务平台"
      },
      username: "",
      password: "",
      captchaCode: "",
      pictureSrc: "",
      captchaToken: "",
      maxTime: 0,
      times: "",
      isFrequency: false,
      eyes_icon: "closed-eye",
      pwdType: "password",
      seen: false,
      visible:false,
      img:'',
      imgs:'',
      tops:'',
      captchaToken:''
    };
  },
  computed: {
    ...mapState("login", ["userinfo", "redirectUrl"]),
    loginBtnStatus() {
      if (isVkhybrid) {
        return !(this.username && this.password);
      } else {
        return false;
      }
    }
  },
  mounted() {
    // console.log('filter-hostname：', window.location.hostname.replace(/^([^-]+)-.*$/ig, '$1'));
    // console.log('headers：{ env：', HOSTS.ENVIROMENT);
  },
  created() {
    this.initPictureFn();
  },
  methods: {
    ...mapActions("login", ["login", "creatCaptcha","createSlideCaptcha"]),
    handleForgetPassword() {
      this.$dialog.alert({
        className: "forgetPasswordDialog",
        message: "请联系 IT 技术支持techservice@vipkid.com.cn 处理密码"
      });
    },
    setFrequency() {
      this.isFrequency = true;
       let that = this;
      // this.creatCaptcha().then(res => {
      //   that.pictureSrc = res.base64String;
      //   that.captchaToken = res.captchaToken;
      //   this.setTimeFn();
      // });
    },
    eyeChange() {
      this.seen = !this.seen;
      this.pwdType = this.seen ? "text" : "password";
      this.eyes_icon = this.seen ? "eye-o" : "closed-eye";
    },
    initPictureFn() {
      let that = this;
      // this.creatCaptcha().then(res => {
      //   that.pictureSrc = res.base64String;
      //   that.captchaToken = res.captchaToken;
      //   this.setTimeFn();
      // });
    },
    setTimeFn() {
      clearInterval(this.times);
      this.maxTime = 0;
      this.times = setInterval(() => {
        this.maxTime++;
        if (this.maxTime > 180) {
          clearInterval(this.times);
        }
      }, 1000);
    },
    visiblefalse(data){
      this.visible = data;
    },
    handleLogin() {
      const username = this.username.trim();
      const password = this.password;
      // const captchaCode = this.captchaCode;
      // const captchaToken = this.captchaToken;
      // if (this.maxTime > 180) {
      //   return this.$toast("验证码已过期，请点击图片刷新");
      // }
      if (!username) {
        return this.$toast("请输入用户名");
      }
      if (!password) {
        return this.$toast("请输入密码");
      }
      if (password.length < 6) {
        return this.$toast("密码至少6位");
      }
      // if (captchaCode.length != 6) {
      //   return this.$toast("图形验证码必须是6位");
      // }
      // if (!captchaCode) {
      //   return this.$toast("请输入图形验证码");
      // }
      this.imgfundata();

      //以下为临时注释
      // this.login({ username, password, captchaCode, captchaToken })
      //   .then(res => {})
      //   .catch(err => {
      //     // this.initPictureFn();
      //   });
    },
    loginfun(x){
      this.login({ username:this.username.trim(), password:this.password, captchaCode:x, captchaToken:this.captchaToken })
        .then(res => {
          this.visible = false;
        })
        .catch(err => {
          this.visible = false;
        });
    },
    imgfundata(){
      this.createSlideCaptcha().then(res =>{
        this.img = 'data:image/jpeg;base64,' + res.backImage;
        this.imgs = 'data:image/jpeg;base64,' + res.slideImage;
        var numberyaxis = Number(res.yAxis);
        this.tops = numberyaxis + '%';
        this.captchaToken = res.captchaToken;
        this.visible = true;
      }).catch(err => {
        console.log(res);
      })
    },
    jump(data) {
      const { bind, mfaTempToken, mfaType, ssoToken } = data;
      if (bind !== 0) {
        return this.$toast("请到pc上绑定账号");
      }
      if (mfaType && Array.isArray(mfaType) && !mfaType.length) {
        return navigationTo(this.redirectUrl, ssoToken);
      }
      if (mfaTempToken && mfaType && Array.isArray(mfaType) && mfaType.length) {
        return this.$router.push({ name: "verify" });
      }
      this.$toast("请到pc上进行操作");
    }
  },
  watch: {
    userinfo: {
      handler(data) {
        this.jump(data);
      },
      deep: true
    }
  },
  components: {
    VkdHeader,
    Alert
  }
};
</script>

<style lang="scss" scoped>
.picture-box {
  // height: 44px;
  display: flex;
  .picture-code {
    // width: 160px;
    // height: 44px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
.eye-box {
  display: flex;
}
.van-hairline--top-bottom::after {
  border-top: none;
}
.mainBd {
  max-width: 375px;
  margin: 0 auto;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.van-cell {
  padding-left: 0;
  padding-right: 0;
}
.van-cell:not(:last-child)::after {
  margin-left: 0;
}
.loginBtn {
  padding: 24px 0 16px;
}
.forgetPassword,
.fivefrequency {
  color: #ff6422;
  font-size: 12px;
}
.title {
  padding-top: 20px;
  padding-bottom: 3px;
  font-size: 14px;
}
</style>

<style lang="scss">
.forgetPasswordDialog {
  font-size: 12px;
  text-align: center;
  .van-dialog__confirm,
  .van-dialog__confirm:active {
    color: #38f;
  }
}
</style>
